import { format } from 'date-fns-tz'

export function formatDate(date, timeZoneId, is_full_width) {
  return format(date, is_full_width ? 'EEEE, dd MMMM yyyy' : 'EEE, dd MMM yy', {
    timeZone: timeZoneId,
  })
}
